import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, hidePreloader, show_popup, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import TermsConditionsPopup from "./TermsConditionsPopup";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import DatePicker from "react-datepicker";

class BookingSummaryUpdatePage extends Component {
	constructor(props) {
		super(props);
		this.goBookingDetails = this.goBookingDetails.bind(this);
		this.handleTermsConditionsPopup = this.handleTermsConditionsPopup.bind(this);
		this.sendError = this.sendError.bind(this);

		this.state = {
			showButtons: false,
			to_show: {},
			signature_json: "{\"lines\":[]}",
			signature_png: '',
			terms_1: "0",
			terms_2: "0",
			terms_3: "0",
			terms_4: "0",
			terms_5: "0",
//			terms_6: "0",
			status: "",
			showError: false
		};
	}

	handleTermsConditionsPopup(signature_json, signature_png, terms_1, terms_2, terms_3, terms_4, terms_5/*, terms_6*/, status) {
		this.setState({
			signature_json: signature_json,
			signature_png: signature_png,
			terms_1: terms_1,
			terms_2: terms_2,
			terms_3: terms_3,
			terms_4: terms_4,
			terms_5: terms_5/*, terms_6: terms_6*/,
			status: status
		});
//		console.log('handleTermsConditionsPopup', signature_json, signature_png, status);

		this.props.handleTermsConditions(signature_json, signature_png, terms_1, terms_2, terms_3, terms_4, terms_5/*, terms_6*/, status);
	}

	goBookingDetails() {
		show_popup(<TermsConditionsPopup
			to_show={this.state.to_show}
			booking_form_data={this.props.summary_page_info.prepared}
			goNext={()=>{
				this.setState({showButtons: false});
			}}
			handleTermsConditionsPopup={this.handleTermsConditionsPopup}
			TermsConditions={window.terms_conditions}
			handleSetSomeBlock={this.props.handleSetSomeBlock}
		/>, {auto_close: false});
	}
//https://gecko2.my.mac/booking-manage/online-booking/?location=update&start_date=3eb93458-eeda-415e-b774-21691426a42a
	componentDidMount() {
		if (this.props.summary_page_info.prepared.summary.booking_summary &&  this.props.summary_page_info.prepared.summary.booking_summary.html !== undefined) {
			$('#booking-result-table').html(this.props.summary_page_info.prepared.summary.booking_summary.html);
			this.setState({showButtons: true, showError: false });
		}
		else
			this.setState({showError: true});
	}

	componentDidUpdate(previousProps) {

		if (this.props.scroll_to_element === 'id_booking_summary_page') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
		if (!this.state.showError){
			if (this.props.summary_page_info.prepared.summary && this.props.summary_page_info.prepared.summary.booking_summary && this.props.summary_page_info.prepared.summary.booking_summary.html !== undefined)
				$('#booking-result-table').html(this.props.summary_page_info.prepared.summary.booking_summary.html);
			else
				this.setState({showError: true});
		}


	}

	sendError(e) {

		let fields = this.props.booking_field_list.error_limit;
		let btn = e.target;
		let form_inputs = $(btn).closest('.totalerror');
		let params = {};
		let t = this;

		Object.keys(fields).map((item) => {
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				params['booking['+fields[item]+']'] = el[0].value.trim();
			}
		});

		params.action = 'api/booking/totalerror';

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {
				if(resp.error !== undefined)
					showPopupWithGoBack(resp.error);
				else if(resp.data !== undefined)
					showPopupWithGoBack('<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png" alt="gecko" style={{float:"left",margin:"0px 20px 0px 0px"}}>Your request has been sent. Thank you for choosing to Go with the Gecko.');

//				console.log(resp);

				t.setState({showError: false});

				hidePreloader();
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	render() {
		return (<>
			<RedirectOnlyHome />

			<div id={'id_booking_summary_page'} className={'summary'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				{
					(this.state.showError || this.props.summary_page_info.error_messages || this.props.summary_page_info.prepared.summary.booking_summary && this.props.summary_page_info.prepared.summary.booking_summary.html === undefined || this.props.summary_page_info.prepared.summary.booking_summary.html ) &&
					(
						<div className="col" id={'booking-result-table'}>
							<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
								 alt="gecko headset" className="alignleft"/>
							<p className="total-error-heading" style={{color:"#d63545",fontSize:"18px"}}>
								<strong>Opps, Something went wrong ?!</strong>
							</p>

							<p style={{fontSize:"18px", marginTop:"18px", marginBottom:"18px" }}>{this.props.summary_page_info.error_messages}</p>

							<p style={{fontSize:"16px", marginTop:"18px", marginBottom:"18px" }}>
								Sorry about this. You can go back and try again or, leave your name and number and we'll call you back immediately to finalize!
							</p>
							<div className="col">
								<div className="row totalerror">
									<div className="form-group col-md-6 fake-placeholder">
										<div className="placeholder">
											<label htmlFor="totalerror_name">Name</label><span className="star">*</span>
										</div>
										<input placeholder={'Name'} className="form-control required" type="text" name="totalerror_name"/>
									</div>
									<div className="form-group col-md-6 fake-placeholder">
										<div className="placeholder">
											<label htmlFor="totalerror_phone">Phone</label><span className="star">*</span>
										</div>
										<input placeholder={'Phone'} className="form-control required" type="text" name="totalerror_phone"/>
									</div>
								</div>
								<div className="row justify-content-center">
									<div className="form-group col-auto">
										<input type="button" className="btn btn-success" value="Send" onClick={this.sendError} />
									</div>
								</div>
							</div>

						</div>
					)
				}
				{
					this.state.showButtons &&
					(
						<>
							<div className="row justify-content-center justify-content-md-center">
								<div className="col-6 text-center">
									<input type="button" className="go-btn go-next"
										   style={{display: "inline-block"}}  onClick={this.goBookingDetails}/>
								</div>
							</div>
						</>
					)
				}
			</div>
		</>);
	}
}

export default BookingSummaryUpdatePage;